import type { Post } from '../types'

export const posts: Post[] = [
  {
    slug: 'signs-your-crawl-space-needs-repair',
    title: {
      en: 'Signs Your Crawl Space Needs Professional Repair',
      es: 'Señales de que tu Crawl Space Necesita Reparación Profesional',
    },
    excerpt: {
      en: 'Musty odors, cupped hardwood floors, rising energy bills, and cold rooms above an unheated crawl space are early warnings of moisture damage. Here is how Washington homeowners can tell the difference between routine dampness and structural trouble that calls for crawl space repair.',
      es: 'Olor a humedad, pisos de madera abombados, facturas de energía altas y cuartos fríos son señales tempranas de daño por humedad. Así distinguen los propietarios de Washington entre humedad normal y un problema estructural que requiere reparación.',
    },
    category: { en: 'Crawl Space', es: 'Crawl Space' },
    date: '2025-11-18',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/cbe1411c-c759-432d-8956-b7b7d650ba17.jpg',
    serviceSlug: 'crawl-space-encapsulation',
  },
  {
    slug: 'prevent-foundation-damage-washington-climate',
    title: {
      en: "How to Prevent Foundation Damage in Washington's Climate",
      es: 'Cómo Prevenir Daños en los Cimientos con el Clima de Washington',
    },
    excerpt: {
      en: 'Nine months of rain, saturated clay soils, and poor downspout drainage put constant pressure on Pacific Northwest foundations. Simple seasonal maintenance — grading, gutter extensions, and an annual foundation inspection — prevents the cracks that lead to expensive structural repair.',
      es: 'Nueve meses de lluvia, suelos arcillosos saturados y desagües deficientes presionan constantemente los cimientos del noroeste. Un mantenimiento estacional simple previene las grietas que llevan a reparaciones costosas.',
    },
    category: { en: 'Foundation', es: 'Cimientos' },
    date: '2025-10-30',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/102349f3-1f63-438f-989a-40050dd51985.jpg',
    serviceSlug: 'foundation-repair',
  },
  {
    slug: 'why-professional-insulation-matters',
    title: {
      en: 'Energy Efficiency: Why Professional Insulation Matters',
      es: 'Eficiencia Energética: Por Qué Importa el Aislamiento Profesional',
    },
    excerpt: {
      en: 'Insulation only performs when it is installed tight to the subfloor with no gaps, compressions, or moisture behind it. We break down R-values for Washington homes, the real cost of failed batts, and what a professional insulation installation should include.',
      es: 'El aislamiento solo funciona si se instala ajustado al subpiso, sin huecos, compresiones ni humedad detrás. Explicamos los valores R para casas de Washington y qué debe incluir una instalación profesional.',
    },
    category: { en: 'Insulation', es: 'Aislamiento' },
    date: '2025-10-08',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/4167e57a-6a60-4e39-80f3-75ffe1d2fb41.jpg',
    serviceSlug: 'insulation-installation',
  },
]
